<script setup lang="ts">
import { ref } from "vue";

import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import useTranslate from "@/hooks/useTranslate/useTranslate";

export interface Props {
    certificateNumber: string;
    isLoading: boolean;
}

const props = defineProps<Props>();

const isCopied = ref<boolean>(false);

async function copyToClipboard() {
    try {
        await navigator.clipboard.writeText(props.certificateNumber);
        isCopied.value = true;
    } catch (e) {
        isCopied.value = false;
        useBugTracker("copy to clipboard", BugTrackerSection.WARNING, {
            message: e?.message,
        });
    }
}
</script>

<template>
    <div class="tiw__step__voucherSent__body__voucher">
        <div class="tiw__step__voucherSent__body__voucher__show">
            <p class="tiw__step__voucherSent__body__voucher__show__title">
                {{ useTranslate("tiw__voucherNumber") }}
            </p>
            <p class="tiw__step__voucherSent__body__voucher__show__number">
                {{ props.certificateNumber }}
            </p>
        </div>
        <button
            :disabled="props.isLoading"
            class="tiw__step__voucherSent__body__voucher__copy"
            @click="copyToClipboard"
        >
            {{ useTranslate(isCopied ? "tiw__voucher__copied__text" : "tiw__voucher__copy__text") }}
        </button>
    </div>
</template>

<style></style>
